import { useSyncExternalStore } from 'react';
import type { PaymentProvider } from './provider';

/**
 * Store mínimo (módulo, sem React) do provedor escolhido no seletor.
 *
 * Fica fora do React de propósito: o client HTTP do Repasses lê daqui na hora
 * de montar cada request (mutations inclusive), sem precisar passar o provedor
 * por parâmetro em 25 funções. `null` = sem seletor = sem header.
 */
let current: PaymentProvider | null = null;
const listeners = new Set<() => void>();

export const getCurrentProvider = (): PaymentProvider | null => current;

export const setCurrentProvider = (next: PaymentProvider | null): void => {
  if (next === current) return;
  current = next;
  listeners.forEach((l) => l());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Provedor atual, reativo. As query keys do Repasses entram por aqui. */
export const useCurrentProvider = (): PaymentProvider | null =>
  useSyncExternalStore(subscribe, getCurrentProvider, getCurrentProvider);
